export default function About() {
  return (
    <section
      id="about"
      className="relative w-full px-4 py-14 sm:py-24
      bg-gradient-to-b from-[#FFF2F7] via-[#FFF9FB] to-white
      text-[#4B3049] overflow-hidden"
    >
      {/* ✨ Soft Floating Glow */}
      <div className="absolute -top-10 left-1/4 w-32 h-32 sm:w-64 sm:h-64 bg-pink-300/20 blur-3xl rounded-full -z-10" />
      <div className="absolute bottom-0 right-1/4 w-28 h-28 sm:w-56 sm:h-56 bg-purple-300/20 blur-3xl rounded-full -z-10" />

      {/* 🔮 Header */}
      <div className="text-center mb-10 sm:mb-16">
        <p className="uppercase tracking-[0.35em] text-[10px] sm:text-xs text-[#C07A9C] mb-2">
          Our Story
        </p>
        <h2 className="text-2xl sm:text-5xl font-extrabold text-[#9F3F63]">
          Made With Heart
        </h2>
        <p className="mt-3 text-xs sm:text-base text-[#9B6A88] max-w-xl mx-auto">
          Not a factory. Not a brand.  
          Just hands, yarn, and a dream.
        </p>
      </div>

      {/* 🪞 Glass Card */}
      <div
        className="relative max-w-4xl mx-auto
        bg-white/75 backdrop-blur-xl
        border border-pink-100
        rounded-3xl
        p-5 sm:p-10
        shadow-[0_10px_40px_rgba(255,182,193,0.25)]"
      >
        {/* Story */}
        <div className="space-y-4 sm:space-y-6 text-xs sm:text-[15px] leading-relaxed">
          <p>
            It started quietly — a{" "}
            <span className="font-semibold text-[#B14C77]">
              student with a crochet hook
            </span>
            , spare yarn, and long nights filled with imagination.
            No big plan. No investors. Just passion.
          </p>

          <p>
            Stitch by stitch, something warm took shape.
            Not just products — but{" "}
            <span className="italic text-[#D15A8F]">
              little pieces of comfort and care
            </span>
            .
          </p>

          <p>
            We believe handmade shouldn’t be expensive or exclusive.
            It should feel close to home —
            <span className="font-semibold text-[#B14C77]">
              made for common people, by common people
            </span>
            ❤️
          </p>
        </div>

        {/* ✨ Vision */}
        <div className="mt-8 sm:mt-12 bg-gradient-to-r from-[#FFF1F6] to-[#FFE7F1]
        border border-pink-200 rounded-2xl px-5 py-4 sm:px-8 sm:py-6 shadow-sm">
          <h3 className="font-bold text-sm sm:text-lg text-[#B14C77] mb-2 flex items-center gap-2">
            ✨ Our Vision
          </h3>
          <p className="text-xs sm:text-sm leading-relaxed text-[#6B3442]">
            To turn simple yarn into stories, warmth into memories,
            and small dreams into something that reaches hearts —
            one stitch at a time. 🧶
          </p>
        </div>

        {/* 💎 Highlights */}
        <div className="mt-8 sm:mt-12">
          <h3 className="font-bold text-sm sm:text-lg text-[#B14C77] mb-3">
            Why People Choose Us
          </h3>

          <div className="grid sm:grid-cols-3 gap-3 sm:gap-4 text-xs sm:text-sm">
            <div className="bg-white rounded-xl p-4 border border-pink-100 shadow-sm">
              💗 Affordable handmade pieces
            </div>
            <div className="bg-white rounded-xl p-4 border border-pink-100 shadow-sm">
              🧵 Student-driven creativity
            </div>
            <div className="bg-white rounded-xl p-4 border border-pink-100 shadow-sm">
              🌸 Every order supports a dream
            </div>
          </div>
        </div>
      </div>

      {/* 🌸 Brand Signature */}
      <div className="mt-10 sm:mt-16 text-center text-[10px] sm:text-xs tracking-[0.3em] text-[#B57A93]">
        ANE CROCHET — HANDMADE WITH LOVE
      </div>
    </section>
  );
}
